import { render, staticRenderFns } from "./DocumentFeed.vue?vue&type=template&id=7acbec8f&"
import script from "./DocumentFeed.vue?vue&type=script&lang=ts&"
export * from "./DocumentFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports